import api from './api';

/**
 * Bildirim tercihlerini getir
 */
export const getNotificationPreferences = async () => {
  try {
    const response = await api.get('/api/business/notifications/preferences');
    return response.data;
  } catch (error) {
    console.error('Bildirim tercihleri getirilemedi:', error);
    throw error;
  }
};

/**
 * Bildirim tercihlerini güncelle
 */
export const updateNotificationPreferences = async (preferences) => {
  try {
    const response = await api.put('/api/business/notifications/preferences', preferences);
    return response.data;
  } catch (error) {
    console.error('Bildirim tercihleri güncellenemedi:', error);
    throw error;
  }
};

